import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import trans from 'counterpart';
import { addResourceToCompare, setCompareProperty } from '../actions';
import { MAX_COMPARE } from '../constants';

class AddToCompareResources extends React.Component {
  addToCompareResources = () => {
    const { addToCompare, compareListIds, setHasMaxCompare, setHasIdInList, id } = this.props;
    if (compareListIds.length === MAX_COMPARE) {
      return setHasMaxCompare();
    }
    if (compareListIds.indexOf(id) > -1) {
      return setHasIdInList();
    }
    return addToCompare();
  }

  render = () => (
    <button type="button" className="btn btn-link btn-compare hidden-sm-down" onClick={this.addToCompareResources}>
      {trans('label.compare_add')}
    </button>
  );
}

AddToCompareResources.propTypes = {
  addToCompare: PropTypes.func,
  compareListIds: PropTypes.array,
  id: PropTypes.number,
  setHasMaxCompare: PropTypes.func,
  setHasIdInList: PropTypes.func,
};

const mapStateToProps = state => ({
  compareListIds: state.compare.compareListIds
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  addToCompare: () => dispatch(addResourceToCompare(ownProps.id)),
  setHasMaxCompare: () => dispatch(setCompareProperty('hasMaxCompare', true)),
  setHasIdInList: () => dispatch(setCompareProperty('hasIdInList', true))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddToCompareResources);
